import styled, { css } from 'styled-components';

export const VirtualizerContainer = styled.div<{ $isScrollable: boolean }>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    css`
      width: 100%;
      height: 100%;
      overflow: auto;
    `}
`;

export const TreeContainer = styled.div<{ $height: number }>`
  position: relative;
  height: ${({ $height }) => $height}px;
  width: 100%;
`;

export const ItemContainer = styled.div<{ $level: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-left: ${({ theme, $level }) =>
    `calc(${$level} * ${theme.spacing(2)})`};
`;

export const DragLine = styled.div`
  height: ${({ theme }) => theme.spacing(0.5)};
  background: ${({ theme }) => theme.palette.primary.main};

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;

    height: ${({ theme }) => theme.spacing(1)};
    width: ${({ theme }) => theme.spacing(1)};

    transform: translate(-50%, -50%);
    border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
    border-radius: 50%;
  }
`;
